angular.module('app.core', [
    /* Angular modules */
    'ngSanitize'
]);
